import { PayrollDraftEmployeeData } from 'api/gql-utils/employeeOnboardingGql/types';
import {
  Manager,
  BasicDetailsFormFields,
  StatutoryFormFields,
  CompensationFormFields,
  CompensationBreakdownFormFields,
  CtcBreakdownDataForEmployeeOnboarding,
} from './types';
import { routePaths } from 'components/Routes/data';

// Sample data for managers
export const managers: Manager[] = [
  { name: 'Abhinav Krishna Aadiraju', id: 420 },
  { name: 'Priya Sharma', id: 421 },
  { name: 'Rahul Gupta', id: 422 },
  { name: 'Sneha Patel', id: 423 },
];

// Form initial data
export const initialFormData: BasicDetailsFormFields = {
  employeeName: '',
  emailId: '',
  emailNotPresent: false,
  hireDate: null,
  designation: '',
  department: '',
  manager_people_id: null,
  officeLocation: [],
};

// Compliance form initial data
export const initialComplianceData: StatutoryFormFields = {
  pan: '',

  isPfEnabled: false,
  pfStatus: [],
  pfUan: '',

  isEsicEnabled: false,
  esicStatus: [],
  esicIpNumber: '',

  isPtEnabled: false,
  ptState: [],

  isLwfEnabled: false,
  lwfLocation: [],
};

export const initialCompensationData: CompensationFormFields = {
  annualCtc: '',
  variablePay: '',
  salaryStructureType: ['default'],
  salaryStructureId: [''],
};

export const initialCompensationBreakdownData: CompensationBreakdownFormFields = {
  annualCtc: '',
  salaryStructureId: [''],
  ctcBreakdownData: {} as CtcBreakdownDataForEmployeeOnboarding,
};

export const steps = [
  {
    id: 0,
    step: 'basics',
    title: 'Basics',
    route: routePaths.employeeOnboarding.employee.basicDetails,
  },
  {
    id: 1,
    step: 'compensation',
    title: 'Compensation',
    route: routePaths.employeeOnboarding.employee.compensation,
  },

  {
    id: 2,
    step: 'compensation_breakdown',
    title: 'Compensation Breakdown',
    route: routePaths.employeeOnboarding.employee.compensationBreakdown,
  },
  {
    id: 3,
    step: 'compliance',
    title: 'Compliance',
    route: routePaths.employeeOnboarding.employee.compliance,
  },
  { id: 4, step: 'review', title: 'Review', route: routePaths.employeeOnboarding.employee.review },
];

export const getPendingFormFields = (data?: PayrollDraftEmployeeData) => {
  const pendingFormFields = [
    'PAN',
    'Aadhar Number',
    'Bank Account Number',
    'Bank IFSC Code',
    'PF UAN',
    'ESIC IP Number',
    'Phone Number',
    'Gender',
    'Date of Birth',
  ];

  if (!data) {
    return pendingFormFields;
  }

  if (data.userStatutoryDetails?.panNumber) {
    pendingFormFields.splice(pendingFormFields.indexOf('PAN'), 1);
  }

  if (data.userStatutoryDetails?.pfUan) {
    pendingFormFields.splice(pendingFormFields.indexOf('PF UAN'), 1);
  }

  if (data.userStatutoryDetails?.esicIp) {
    pendingFormFields.splice(pendingFormFields.indexOf('ESIC IP Number'), 1);
  }

  return pendingFormFields;
};

//query and mutation keys
export const GET_DRAFT_EMPLOYEE = 'GET_DRAFT_EMPLOYEE';
